import { Button, IconButton, Flex, Tr, Td, Text } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { DownloadIconButton } from 'packages/common-frontend/components/IconButton';

export const EmptyDownloadAssignmentPreviewButton = ({
  buttonLabel,
}: {
  buttonLabel: string;
}) => {
  return (
    <Tr>
      <Td width="80%">
        <Text fontSize="12px">{buttonLabel}</Text>
      </Td>
      <Td pl="0">
        <Text fontSize="12px" textAlign="center">
          N/A
        </Text>
      </Td>
    </Tr>
  );
};

export const LoadingDownloadAssignmentPreviewButton = ({
  buttonLabel,
}: {
  buttonLabel: string;
}) => {
  return (
    <Tr>
      <Td width="80%">
        <Text fontSize="12px">{buttonLabel}</Text>
      </Td>
      <Td pl="0">
        <DownloadIconButton
          label={buttonLabel}
          ariaLabel={buttonLabel || 'download csv'}
          isLoading
        />
      </Td>
    </Tr>
  );
};

export const LoadingEmailServicerReportPreviewButton = () => {
  return (
    <Button
      fontWeight="normal"
      width="100%"
      borderRadius="0"
      borderTop="1px"
      borderColor={colors.gray[200]}
      background="white"
      _hover={{
        background: 'blackAlpha.50',
      }}
    >
      <Flex width="100%" justify="space-between">
        <Text mt="auto" mb="auto">
          Email pro forma servicer report preview
        </Text>
        <IconButton
          marginLeft="2px"
          aria-label="email servicer report preview loading"
          isLoading
        />
      </Flex>
    </Button>
  );
};
